export default {
  viewBox: "0 0 24 24",
  html: "<path d=\"M6 17c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6zm6-5a3 3 0 1 1 0-6 3 3 0 0 1 0 6M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2\"/>"
};